import { ERROR_MESSAGE_REQUIRED } from '../../config'
import FormSlide from '../FormSlide'
import { selectErrorHandling } from './common'

export default function WhyJoinSlide (props) {
  return (
    <FormSlide
      title='Why join Aragon?'
      stageName='Finding your place at Aragon'
      description='Be part of a network of representatives that wants to advocate for decentralized governance, engage, empower and represent your community on a global scale with people of like minds.'
      formData={[
        {
          text: 'Why do you want to join Aragon?',
          label: 'joinReason',
          placeholder: '',
          type: 'big-text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        },
        {
          text: 'How much time would you be able to offer?',
          label: 'timeToOffer',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: '1-2 hours a week', text: '1-2 hours a week' },
            { value: '2-7 hours a week', text: '2-7 hours a week' },
            { value: '7-14 hours a week', text: '7-14 hours a week' },
            { value: '14-28 hours a week', text: '14-28 hours a week' },
            { value: 'Full time', text: 'Full time' }
          ]
        },
        {
          text: 'How did you hear about us?',
          label: 'referredBy',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: 'Twitter', text: 'Twitter' },
            { value: 'Discord', text: 'Discord' },
            { value: 'Forum', text: 'Aragon Forum' },
            { value: 'Referral', text: 'Referral' },
            { value: 'Online Ad', text: 'Online Ad' }
          ]
        },
        {
          text: 'If someone referred you, who was it?',
          label: 'referrer',
          placeholder: '',
          type: 'text-box'
        },
        {
          text: 'How knowledgeable are you about DAOs',
          label: 'daoKnowledge',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: 'Very little', text: 'Very little' },
            { value: 'Started learning', text: 'Started learning' },
            { value: 'Very familiar', text: 'Very familiar' },
            { value: 'Expert', text: 'Expert' }
          ]
        },
        {
          text: 'Have you participated in any DAOs before?',
          label: 'isFirstDAO',
          placeholder: '',
          type: 'select',
          errorHandling: selectErrorHandling(''),
          options: [
            { value: 'No', text: 'No' },
            { value: 'Yes', text: 'Yes' }
          ]
        }
      ]}
      {...props}
    />
  )
}
